/* TILEN rabatvisning. Serveren (snippets/tilen-spar.liquid, price.liquid) tegner badge, rød pris, overstreget
   førpris og "Spar 26 kr." ud fra førpris minus pris. Nøgleringens tilvalg (gravering, kort) skifter pris uden
   at siden genrenderes, så tilen-personalizer kalder window.tilenRabat.set(pris, førpris) (begge i øre).
   Teksten skal være ens med Liquid-udgaven: "Spar 26 kr" / "Spar 26,50 kr". */
(function () {
  function kr(cents) {
    var hele = cents % 100 === 0;
    return (cents / 100).toLocaleString('da-DK', {
      minimumFractionDigits: hele ? 0 : 2,
      maximumFractionDigits: hele ? 0 : 2
    }) + ' kr';
  }

  function set(price, compare) {
    var wrap = document.querySelector('product-info [data-tilen-price]');
    var box = wrap && wrap.querySelector('.price');
    var badge = document.querySelector('product-info [data-tilen-badge]');
    var on = compare > price;
    var spar = on ? 'Spar ' + kr(compare - price) : '';

    if (box) {
      box.classList.toggle('price--on-sale', on);
      var reg = box.querySelector('.price__regular .price-item--regular');
      if (reg) reg.textContent = kr(price);
      var old = box.querySelector('.price__sale s.price-item--regular');
      if (old) old.textContent = on ? kr(compare) : '';
      var now = box.querySelector('.price__sale .price-item--sale');
      if (now) now.textContent = kr(price);
      var sp = box.querySelector('[data-tilen-spar]');
      if (sp) sp.textContent = spar;
    }
    if (badge) {
      badge.textContent = '';
      if (on) {
        var b = document.createElement('span');
        b.className = 'tilen-rabat-badge';
        b.textContent = spar;
        badge.appendChild(b);
      }
    }
  }

  window.tilenRabat = { kr: kr, set: set };
})();
